import axios from "axios"

export const getConfiguration = () => axios.get("/api/v1/configuration")

export const getLimits = () => axios.get("/api/v3/limits")

export const getRegistrationConfiguration = () => axios.get("/api/v2/snippets/registration")

export const updateFirebaseCloudMessagingRegistrationToken = (token) => axios.put("/api/v2/device/fcm_registration_token", { registration_token: token })
